import { get, post } from './http'

const taskPath = '/task/frontend/'
const TASK = {
    // 获取任务列表
    getTaskList: (params) => {
      return get(`${taskPath}task/list`, params)
    },

    // 互动消息
    getTaskCategory: (params) => {
      return get(`${taskPath}category/list`, params)
    },


    getUserOilInfo: () => {
      return get(`${taskPath}oil/info`)
    },

    exchangeUserOil: () => {
      return post(`${taskPath}oil/exchange`)
    },

    // 倒计时
    // 客户端获取上报任务列表
    getReportTaskList: () => {
      return get('/task/frontend/appPush/task/list')
    },
    // 客户端检查是否可以上报任务
    canReportTask: (params) => {
      return post('/task/frontend/appPush/task/check', params)
    },
    // 客户端开始上报任务
    startReportTask: (params) => {
      return post('/task/frontend/appPush/task/start', params)
    },
    // 客户端完成上报任务
    finishReportTask: (params) => {
      return post('/task/frontend/appPush/task/finish', params)
    },
}


export default TASK